﻿import React from 'react';

import { getEpiData } from '../../../Utils/epiHelpers';

import IconHelper from '@bazooka_se/lf-icons';

/*TODO: When new Lottie animations, use Animation components for icons*/

const ShortCutMenu = (props) => {

    const homeRef = React.useRef();
    const healthRef = React.useRef();
    const lifeRef = React.useRef();
    const accidentRef = React.useRef();
    const allRef = React.useRef();

    const linkHome = getEpiData('link-home', props.mountRootId) || '';
    const linkHealth = getEpiData('link-health', props.mountRootId) || '';
    const linkLife = getEpiData('link-life', props.mountRootId) || '';
    const linkAccident = getEpiData('link-accident', props.mountRootId) || '';
    const linkAll = getEpiData('link-all', props.mountRootId) || '';

    return (
        <section className="shortcutmenublock col-xs-12">
            <div className="section-spacing">
                <div className="shortcutmenublock__content block-spacing">
                    <a className="btn shortcutmenublock__insurance__home" href={linkHome} ref={homeRef}>
                        {/*<HomeIconAnimation container={homeRef} />*/}
                        <div className="img-icon">
                            <img src="/images/home-insurance-blue.svg" />
                        </div>
                        <span className="shortcutmenublock__link-text">Hemförsäkring</span>
                    </a>
                    <a className="btn shortcutmenublock__insurance__health" href={linkHealth} ref={healthRef}>
                        {/*<HealthIconAnimation container={healthRef} />*/}
                        <div className="img-icon">
                            <img src="/images/health-blue.svg" />
                        </div>
                        <span className="shortcutmenublock__link-text">Sjukförsäkring</span>
                    </a>
                    <a className="btn shortcutmenublock__insurance__life" href={linkLife} ref={lifeRef}>
                        {/*<LifeIconAnimation container={lifeRef} />*/}
                        <div className="img-icon">
                            <img src="/images/life-blue.svg" />
                        </div>
                        <span className="shortcutmenublock__link-text">Livförsäkring</span>
                    </a>
                    <a className="btn shortcutmenublock__insurance__accident" href={linkAccident} ref={accidentRef}>
                        {/*<AccidentIconAnimation container={accidentRef} />*/}
                        <div className="img-icon">
                            <img src="/images/accident-blue.svg" />
                        </div>
                        <span className="shortcutmenublock__link-text">Olycksfallsförsäkring</span>
                     </a>
                  
                <a className="btn shortcutmenublock__insurance__all" href={linkAll} ref={allRef}>
                        {/*<AllIconAnimation container={allRef} />*/}
                        <div className="img-icon">
                            <img src="/images/insurance__all-blue.svg" />
                        </div>
                        <span className="shortcutmenublock__link-text">Alla försäkringar</span>
                    </a>
                </div>
            </div>
        </section>
    )
}

export default ShortCutMenu;